import { createApp } from 'vue';
import OpusToMp3Converter from '@/Components/OpusToMp3Converter.vue';
import '@styles/app.css';

createApp(OpusToMp3Converter).mount('#opus-to-mp3-converter');
